import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import Link from 'gatsby-link';

import styles from './links.module.css';

const Links = props => ([
  <Link key="link1" to="/about/" onClick={props.onClickLink} className={`${styles.navBarItem} ${styles.navBarItemFirst}`}>
    <span>About Us</span>
  </Link>,
  <Link key="link2" to="/projects/" onClick={props.onClickLink} className={`${styles.navBarItem} ${styles.navBarItemCenter}`}>
    <span>Our Projects</span>
  </Link>,
  <Link key="link3" to="/blog/" onClick={props.onClickLink} className={`${styles.navBarItem} ${styles.navBarItemLast}`}>
    <span>Our Thoughts</span>
  </Link>,
]);


export default Links;



// WEBPACK FOOTER //
// ./src/components/navbar/links/index.jsx